import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H2, H4 } from "../../AbstractElements";
import { formatMontant, URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

import { formatDate, formatPrice, itemHasPermission } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import useInfosEts from "../InfosEts/InfoApi";
import { Link } from "react-router-dom";
import useFacturesListe, { deleteFactures } from "./apiFacture";

type Facture = { [key: string]: any }

const GestFacture = () => {
    const [filterText, setFilterText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [filteredItems, setFilteredItems] = useState<Facture[]>([]);
    const [refresh, setRefresh] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const factures = useFacturesListe(refresh) || [];
    const etablissement = useInfosEts(refresh) || [];
    const [designation, setDesignation] = useState<string>("");
    const [price, setPrice] = useState<number>(0);
    const [quantity, setQuantity] = useState<number>(0);

    const [data, setData] = useState({
        num: '',
        payer: '',
        // arreter: '',
        details: [] as { designation: string; price: number; quantity: number }[],
        montant: 0,
        etsInfos: 0,
        client: '',
        date_facture: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        num: '',
        payer: '',
        montant: '',
        // arreter: '',
        etsInfos: '',
        details: '',
        client: '',
        date_facture: '',
        id: null
    });

    const [filter, setFilter] = useState({
        month: '',
        date_debut: '',
        date_fin: '',
        status: ''
    });

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        const formattedValue = name == 'payer' ? formatMontant(value) : value

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleDesignationsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        switch (name) {
          case 'quantity':
            setQuantity(Number(value));
            break;
      
          case 'designation':
            setDesignation(value);
            break;
      
          case 'price':
            setPrice(Number(value));
            break;
      
          default:
            break;
        }
    };

    const clearDataForm = () => {
        setData({
            num: '',
            payer: '',
            details: [] as { designation: string; price: number; quantity: number }[],
            // arreter: '',
            montant: 0,
            client: '',
            etsInfos: 0,
            date_facture: '',
            id: null
        });
        setErreur({
            num: '',
            payer: '',
            montant: '',
            // arreter: '',
            etsInfos: '',
            details: '',
            client: '',
            date_facture: '',
            id: null
        });
    }

    const editerData = ({ id }: { id: number }) => {
        const data = filteredItems.find((item) => item.id === id);
        if (data) {
            setData({
                num: data.num,
                payer: data.payer,
                // quantite_litre: data.quantite_litre,
                // arreter: data.arreter,
                montant: data.montant,
                details: [] as { designation: string; price: number; quantity: number }[],
                etsInfos: data.ets_id,
                client: data.client,
                date_facture: data.date_facture,
                id: data.id
            });
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        console.log(data)
        setIsSubmitting(true);
        const url = `${URL_API}/factures/store`
        const Token = JSON.parse(localStorage.getItem("login")!);

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                toast.success("Factures ajouté avec succès !!");
                clearDataForm();
            }


        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.status == 422) {
                setErreur(error.response.data.message);
            }
            console.log(error.response)
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }

    // Fonction pour gérer le changement de filtre
    const changeFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilter((prev) => ({ ...prev, [name]: value }));
    };

    const Confirmation = ({ id }: { id: number }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: "De Vouloir Supprimer cet element ??",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Supprimer !'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteFactures({ id: id }, () => setRefresh(!refresh))
            }
        });
    };

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1; // Mois actuel (1-12)
        let filtered = factures;
        filtered = factures.filter((item) => {
            const itemMonth = new Date(item.date_facture).getMonth() + 1;
            const matchesMonth = selectedMonth ? itemMonth === selectedMonth : itemMonth === currentMonth;
            const matchesSearch = item.num && item.num.toLowerCase().includes(filterText.toLowerCase()) ||
                item.client && item.client.toLowerCase().includes(filterText.toLowerCase()) ||
                item.payer && item.payer.toLowerCase().includes(filterText.toLowerCase()) ||
                item.date_facture && item.date_facture.toLowerCase().includes(filterText.toLowerCase());
            return matchesMonth && matchesSearch;
        });

        // Filtrer par statut
        if (filter.status) {
            filtered = filtered.filter((item) => item.status === filter.status);
        }

        etablissement.map((item, index) => {
            if (item.status == 'actif' && item.is_default == 1) {
                setData((prevState) => ({
                    ...prevState,
                    etsInfos: item.id ?? 0
                }));
            }
        })

        setFilteredItems(filtered);
        setTimeout(() => {
            if (filteredItems.length > 0) {
                setIsLoading(false); // Les données sont chargées, on arrête le loader
              } else {
                setIsLoading(false)
              }
          }, 2000);
    }, [factures, filterText, filter, selectedMonth, etablissement, refresh]);

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    const addToTable = () => {
        if (!designation || price <= 0 || quantity <= 0) {
          toast.info('Tous les champs sont obligatoires');
          return;
        }
      
        setData((prevData) => {
          const newDetails = [
            ...prevData.details,
            { designation, price, quantity },
          ];
          const totalMontant = newDetails.reduce(
            (acc, row) => acc + row.price * row.quantity,
            0
          );
      
          return {
            ...prevData,
            details: newDetails,
            montant: totalMontant,
          };
        });
      
        // Réinitialisation des champs
        setDesignation('');
        setQuantity(0);
        setPrice(0);
    };

    const removeFromTable = (index: number) => {
        setData((prevData) => {
          const updatedDetails = prevData.details.filter((_, i) => i !== index);
          const updatedMontant = updatedDetails.reduce(
            (acc, row) => acc + row.price * row.quantity,
            0
          );
          
          return {
            ...prevData,
            details: updatedDetails,
            montant: updatedMontant,
          };
        });
      };

    return (
        <div className='page-body'>
            {isLoading && filteredItems.length > 0 ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Container fluid>
                        <Row>
                            <Col lg="7">
                                <Card>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col sm="6">
                                                <Label className="me-2">Rechercher:</Label>
                                                <Input
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    type="search"
                                                    value={filterText}
                                                />
                                            </Col>
                                            <Col sm="6">
                                                <Label className="me-2">Filtrer par mois:</Label>
                                                <Input name="type" value={selectedMonth || ''} onChange={handleMonthChange} type="select">
                                                    <option value="">Mois actuel</option>
                                                    <option value="1">Janvier</option>
                                                    <option value="2">Février</option>
                                                    <option value="3">Mars</option>
                                                    <option value="4">Avril</option>
                                                    <option value="5">Mai</option>
                                                    <option value="6">Juin</option>
                                                    <option value="7">Juillet</option>
                                                    <option value="8">Août</option>
                                                    <option value="9">Septembre</option>
                                                    <option value="10">Octobre</option>
                                                    <option value="11">Novembre</option>
                                                    <option value="12">Décembre</option>
                                                </Input>
                                            </Col>

                                        </Row>

                                    </CardBody>
                                </Card>
                                <Table responsive id="all-invoice" striped={true}>
                                    <thead className="bg-info">
                                        <tr>
                                            <th className="text-white">Id</th>
                                            <th className="text-white ps-4">No Factures</th>
                                            <th className="text-white">Clients</th>
                                            <th className="text-white ">Montant Payeé</th>
                                            <th className="text-white ">Rest À Payer</th>
                                            <th className="text-white ">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredItems.map((item, index) => (
                                            <tr key={item.id}>
                                                <th scope='row'>
                                                    <span className="fw-bold">
                                                        #{index + 1}
                                                    </span>
                                                </th>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {item.num}
                                                    </span> <br></br>
                                                    <span>
                                                        {formatDate(item.date_facture)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {item.client}
                                                    </span> 
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {formatPrice(item.total)}
                                                    </span> 
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {formatPrice(item.restapayer)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link className='btn bg-dark btn-xs mx-1 my-1' to={`/factures/show/${item.id}`}>
                                                        <i className='fa fa-eye'></i>
                                                    </Link>
                                                    {
                                                        (itemHasPermission('super admin') || itemHasPermission('gest. factures ecriture')) && (

                                                            item.status === 'payed' ? (
                                                                null
                                                            ) : (
                                                                <>
                                                                    {/* <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerData({ id: item.id })}>
                                                                        <i className='fa fa-pencil'></i>
                                                                    </Btn> */}
                                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id })}>
                                                                        <i className='fa fa-trash'></i>
                                                                    </Btn>
                                                                </>
                                                            )

                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col lg="5">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={handleSubmitData}>
                                            <H4 className="mb-4 text-capitalize">
                                                {data.id == null ? ("Faire Une Facture") : (`"Modifier La Facture ${data.id}`)}
                                            </H4>
                                            <div className="product-info">
                                                <div className="product-group">
                                                    <Row>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Etablissement</Label>
                                                                <Input
                                                                    placeholder="Entrer le type"
                                                                    name="etsInfos"
                                                                    value={data.etsInfos}
                                                                    onChange={changeHandler}
                                                                    type="select"
                                                                    className="form-control" disabled
                                                                >
                                                                    <option value=''>Selectionner...</option>
                                                                    {
                                                                        etablissement.map((item, index) => {
                                                                            if (item.status == 'actif' && item.is_default == 1) {
                                                                                return <option key={index} value={item.id} selected={true}>{item.nom}</option>
                                                                            } return null;
                                                                        })
                                                                    }
                                                                </Input>
                                                                {erreur.etsInfos && (
                                                                    <span className="text-danger">{erreur.etsInfos}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>No Factures</Label>
                                                                <Input
                                                                    placeholder="Entrer le numéro factures"
                                                                    name="num"
                                                                    value={data.num}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.num && (
                                                                    <span className="text-danger">{erreur.num}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Date</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="date_facture"
                                                                    value={data.date_facture}
                                                                    onChange={changeHandler}
                                                                    type="date"
                                                                />
                                                                {erreur.date_facture && (
                                                                    <span className="text-danger">{erreur.date_facture}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Client</Label>
                                                                <Input
                                                                    placeholder="Entrer le nom complet"
                                                                    name="client"
                                                                    value={data.client}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.client && (
                                                                    <span className="text-danger">{erreur.client}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        
                                                        <Col>
                                                        {/* <span>Detials Factures</span> */}
                                                        <hr className="relative" />
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Designations</Label>
                                                                <Input
                                                                    placeholder="Entrer la designations"
                                                                    name="designation"
                                                                    value={designation}
                                                                    onChange={handleDesignationsChange}
                                                                    type="text"
                                                                />
                                                                {/* {designation && (
                                                                    <span className="text-danger">{designation}</span>
                                                                )} */}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>La Quantité</Label>
                                                                <Input
                                                                    placeholder="La quantite"
                                                                    name="quantity"
                                                                    value={quantity}
                                                                    onChange={handleDesignationsChange}
                                                                    type="text"
                                                                />
                                                                {/* {quantity && (
                                                                    <span className="text-danger">{quantity}</span>
                                                                )} */}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>P. Unitaires</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="price"
                                                                    value={price}
                                                                    onChange={handleDesignationsChange}
                                                                    type="number"
                                                                />
                                                                {/* {price && (
                                                                    <span className="text-danger">{price}</span>
                                                                )} */}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm='12'>
                                                            <Btn color="light-dark" onClick={addToTable} className="w-100 for-light">Ajouter les detailes</Btn>
                                                            <Btn color="light-light" onClick={addToTable} className="w-100 for-dark">Ajouter les detailes</Btn>
                                                        </Col>
                                                        
                                                        <Col sm='12'>
                                                            <Table className="mb-4" responsive striped>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Designations</th>
                                                                        <th>Prix</th>
                                                                        <th>Quantité</th>
                                                                        <th>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data.details.map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>{row.designation}</td>
                                                                            <td>{row.price.toLocaleString()} GNF</td>
                                                                            <td>{row.quantity}</td>
                                                                            <td>
                                                                                <Btn color="light-danger" size="xs" type="button" onClick={() => removeFromTable(index)}>
                                                                                    <i className="fa fa-trash"></i>
                                                                                </Btn>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                        <Col sm='12'>
                                                        <hr className="relative" />
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Montant Total</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="montant"
                                                                    value={data.montant}
                                                                    onChange={changeHandler}
                                                                    type="number"
                                                                    disabled
                                                                />
                                                                {erreur.montant && (
                                                                    <span className="text-danger">{erreur.montant}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Montant Payé</Label>
                                                                <Input
                                                                    placeholder="Entrer le montant payé"
                                                                    name="payer"
                                                                    value={data.payer}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.payer && (
                                                                    <span className="text-danger">{erreur.payer}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        {/* <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Arrêter</Label>
                                                                <Input
                                                                    placeholder="Veuillez indiquer l'arrêter"
                                                                    name="arreter"
                                                                    value={data.arreter}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.arreter && (
                                                                    <span className="text-danger">{erreur.arreter}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col> */}
                                                        
                                                        
                                                    </Row>
                                                </div>
                                            </div>
                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. factures ecriture')) && (
                                                    <div className="text-end">
                                                        <Btn color="info" type="submit" disabled={isSubmitting}>
                                                            {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                                        </Btn>
                                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                            Annuler
                                                        </Btn>
                                                    </div>
                                                )}

                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                 </>
            )}
        </div>
    );
};

export default GestFacture